import React from "react";

function SettingsPage() {
    return (
        <div>Settings</div>
    );
}

export default SettingsPage;